/**
 * 素材文件 URL 工具
 *
 * 关键：斜杠不编码（/ 在 query string 中合法），避免 %2F（编码斜杠）
 * 在 Servlet 容器/代理层被特殊处理导致「页面能显示、复制 URL 却 404」。
 */
export function fileUrl(path) {
  if (/^https?:\/\//i.test(path)) return path
  return `/api/v1/files/view?path=${encodeURIComponent(path).replace(/%2F/gi, '/')}`
}

/**
 * 缩略图 URL（列表 / 选择框的预览格专用）
 *
 * 原图动辄 2K/4K、单张几 MB，一页十几张就是回显慢的主因 —— 预览格只有 120~150px 高，
 * 没必要渲染原图。后端 /files/thumb 按需缩放并落盘缓存，拿不到缩略图时自动回退原图。
 *
 * 注意：这里**只用于小图预览**。点开大图看细节（preview-src-list）、下载、导出 PSD
 * 以及最终喂给模型的图，都必须继续用 fileUrl / 相对路径（原图）。
 *
 * @param {string} path  素材相对路径（data/outputs/...）
 * @param {number} width 目标渲染宽度，默认 320
 */
export function thumbUrl(path, width) {
  // 公网地址（remote_path）由云端托管，本地无法缩放，直接用原地址
  if (/^https?:\/\//i.test(path)) return path
  return `/api/v1/files/thumb?path=${encodeURIComponent(path).replace(/%2F/gi, '/')}&w=${width || 320}`
}

export function downloadUrl(path) {
  if (/^https?:\/\//i.test(path)) return path
  return `/api/v1/files/download?path=${encodeURIComponent(path).replace(/%2F/gi, '/')}`
}

/**
 * 触发浏览器下载一个 Blob（打包下载用）。
 * 调用方负责先判断 blob 是不是后端返回的 JSON 错误。
 */
export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename || 'download'
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

/**
 * 打包下载的公共处理：blob 里是 JSON 时说明后端返回了错误，转成可读提示。
 * @returns {Promise<string>} 成功返回 ''，失败返回提示文案
 */
export async function readZipError(blob) {
  if (!blob || !blob.type || blob.type.indexOf('json') < 0) {
    return ''
  }
  try {
    const text = await blob.text()
    const obj = JSON.parse(text)
    return obj.message || '打包失敗'
  } catch (e) {
    return '打包失敗'
  }
}
